import Axios from "axios";
import {
  AccountBaseUrl,
  ApiBaseUrl,
  KycBaseUrl,
  Menu,
  SecurityBaseUrl,
} from "../config/config";
import { ApiResultModel } from "../models/common.model";
import {
  AuthenticateRequest,
  AuthenticateResponse,
  ChangePasswordRequest,
  ChangeUserPasswordByAdminRequest,
  CheckOtpRequest,
  CheckOtpResponse,
  GetSideMenu,
  GetUsersRequest,
  GetUsersResponse,
  RegisterUserRequest,
  SendOtpRequest,
  UpdateUserRequest,
} from "../models/security.model";
//kyc
export const sendOtp = (data: SendOtpRequest): Promise<string> => {
  return Axios.post<ApiResultModel<string>>(
    ApiBaseUrl + AccountBaseUrl + "/SendOtp",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const CheckOtp = (
  data: CheckOtpRequest
): Promise<ApiResultModel<CheckOtpResponse>> => {
  return Axios.post<ApiResultModel<CheckOtpResponse>>(
    ApiBaseUrl + AccountBaseUrl + "/CheckOtp",
    data
  ).then((result) => {
    return result.data;
  });
};

export const authenticate = (
  data: AuthenticateRequest
): Promise<AuthenticateResponse> => {
  return Axios.post<ApiResultModel<AuthenticateResponse>>(
    ApiBaseUrl + AccountBaseUrl + "/Authenticate",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const changeUserPassword = (
  data: ChangePasswordRequest
): Promise<ApiResultModel<boolean>> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SecurityBaseUrl + "/changeUserPassword",
    data
  ).then((result) => {
    return result.data;
  });
};

// this service must move to menu service

export const GetMenus = (): Promise<GetSideMenu> => {
  return Axios.get<ApiResultModel<GetSideMenu>>(
    ApiBaseUrl + Menu + "/GetUserMenus"
  ).then((result) => {
    return result.data.data;
  });
};

export const ResetUserPassword = (data: {
  username: string;
}): Promise<{ password: string }> => {
  return Axios.post<ApiResultModel<{ password: string }>>(
    ApiBaseUrl + SecurityBaseUrl + "/ResetUserPassword",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const ChangeUserPasswordByAdmin = async (
  data: ChangeUserPasswordByAdminRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + SecurityBaseUrl + "/ChangeUserPasswordByAdmin",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const UpdateUser = async (data: UpdateUserRequest): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    // SERVIES_URL
    ApiBaseUrl + SecurityBaseUrl + "/UpdateUser",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetUsers = async (
  data: GetUsersRequest
): Promise<ApiResultModel<GetUsersResponse[]>> => {
  return await Axios.post<ApiResultModel<GetUsersResponse[]>>(
    // SERVIES_URL
    ApiBaseUrl + SecurityBaseUrl + "/GetUsers",
    data
  ).then((result) => {
    return result.data;
  });
};

export const RegisterUser = async (
  data: RegisterUserRequest
): Promise<{ userId: number; password: string }> => {
  return await Axios.post<ApiResultModel<{ userId: number; password: string }>>(
    // SERVIES_URL
    ApiBaseUrl + SecurityBaseUrl + "/RegisterUser",
    data
  ).then((result) => {
    return result.data.data;
  });
};
